import { useReadHostServiceByMonitorIdQuery } from 'services/hostService'
import { DateTime } from 'luxon'
import styles from './HostServiceDetailInformation.module.css'
import classNames from 'classnames'

export type HostServiceDetailGeneralInformationProps = {
    hostServiceId: number,
    monitorId?: number
}

export const HostServiceDetailInformation = (props: HostServiceDetailGeneralInformationProps): JSX.Element => {
    const {
        hostServiceId = -1,
        monitorId = -1
    } = props


    const readMonitorRunResultByMonitorIdQueryOptions = {
        refetchOnMountOrArgChange: true,
    };

    const readHostServiceByMonitorIdQueryParams = {
        monitorId: monitorId,
        hostServiceId: hostServiceId,
        firstDay: DateTime.fromMillis(0).toSQLDate() || '',
        lastDay: DateTime.fromMillis(0).toSQLDate() || '',
    }

    const {
        data: readHostServiceByMonitorIdQueryData,
        isLoading: readHostServiceByMonitorIdQueryDataIsLoading,
        isFetching: readHostServiceByMonitorIdQueryDataIsFetching,
        error: readHostServiceByMonitorIdQueryError
    } = useReadHostServiceByMonitorIdQuery(readHostServiceByMonitorIdQueryParams, readMonitorRunResultByMonitorIdQueryOptions);

    const gridItemNameClasses = classNames(
        styles.HostServiceDetailInformation__GridItem,
        styles[`HostServiceDetailInformation__GridItem--Name`]
    )

    const gridItemValueClasses = classNames(
        styles.HostServiceDetailInformation__GridItem,
        styles[`HostServiceDetailInformation__GridItem--Value`]
    )  

    const handleRatingValue = (value: any) => {
        if (value === undefined || value === null){
            return 'N/A'
        }

        return value
    }

    const handlePetsValue = (value: any) => {
        if (value === undefined || value === null){
            return 'N/A'
        }

        return value
    }

    const rating = handleRatingValue(readHostServiceByMonitorIdQueryData?.rating)
    const pets = handlePetsValue(readHostServiceByMonitorIdQueryData?.pets)
    return (
        <div>
            <h2 className={styles.HostServiceDetailInformation__Heading2}>Information</h2>
            <div className={styles.HostServiceDetailInformation__Grid}>
                {/* <div className={styles.HostServiceDetailInformation__GridItem}> */}
                    <div 
                        className={gridItemNameClasses}
                    >
                        City:
                    </div>
                    <div  
                        className={gridItemValueClasses}
                    >
                        {readHostServiceByMonitorIdQueryData?.city}
                    </div>
                    <div 
                        className={gridItemNameClasses}
                    >
                        Bedrooms:
                    </div>
                    <div  
                        className={gridItemValueClasses}
                    >
                        {readHostServiceByMonitorIdQueryData?.bedrooms}
                    </div>
                    <div 
                        className={gridItemNameClasses}
                    >
                        Beds:
                    </div>
                    <div  
                        className={gridItemValueClasses}
                    >
                        {readHostServiceByMonitorIdQueryData?.beds}
                    </div>              
                    <div 
                        className={gridItemNameClasses}
                    >
                        Rating:
                    </div>
                    <div  
                        className={gridItemValueClasses}
                    >
                        {rating}
                    </div>
                    <div 
                        className={gridItemNameClasses}
                    >
                        Reviews:
                    </div>
                    <div  
                        className={gridItemValueClasses}
                    >
                        {readHostServiceByMonitorIdQueryData?.ratingsCount}
                    </div>
                    <div 
                        className={gridItemNameClasses}
                    >
                        Pets:
                    </div>
                    <div  
                        className={gridItemValueClasses}
                    >
                        {pets}
                    </div>
            </div>
            {/* <Container>
                <Grid container sx={{ p: '16px' }}>
                    <Grid item xs={6}>
                        <div>
                            <Box sx={{ fontWeight: '700' }}>
                                City
                            </Box>
                            <Box>
                                {readHostServiceByMonitorIdQueryData?.city}
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <div>
                            <Box sx={{ fontWeight: '700' }}>
                                Bedrooms
                            </Box>
                            <Box>
                                {readHostServiceByMonitorIdQueryData?.bedrooms}
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <div>
                            <Box sx={{ fontWeight: '700' }}>
                                Beds
                            </Box>
                            <Box>
                                {readHostServiceByMonitorIdQueryData?.beds}
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <div>
                            <Box sx={{ fontWeight: '700' }}>
                                Pets
                            </Box>
                            <Box>
                                {readHostServiceByMonitorIdQueryData?.pets}
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <div>
                            <Box sx={{ fontWeight: '700' }}>
                                Rating
                            </Box>
                            <Box>
                                {readHostServiceByMonitorIdQueryData?.rating}
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <div>
                            <Box sx={{ fontWeight: '700' }}>
                                Reviews
                            </Box>
                            <Box>
                                {readHostServiceByMonitorIdQueryData?.ratingsCount}
                            </Box>
                        </div>
                    </Grid>
                </Grid>
            </Container> */}
        </div>
    )
}
